// VoK MUI Base Styles
import colors from "app/assets/theme-dark/base/colors";
import borders from "app/assets/theme-dark/base/borders";

// Spk UI Dashboard PRO helper functions
import pxToRem from "app/assets/theme-dark/functions/pxToRem";

const {inputColors} = colors;
const {borderWidth, borderRadius} = borders;

const input = {
    styleOverrides: {
        root: {
            display: "flex !important",
            padding: `${pxToRem(8)} ${pxToRem(12)}`,
            border: `${borderWidth[1]} solid ${inputColors.borderColor.main}`,
            borderRadius: `${borderRadius.md} !important`,

            "& fieldset": {
                border: "none",
            },
        },

        input: {
            height: pxToRem(22),
            width: "max-content !important",
        },

        inputSizeSmall: {
            height: pxToRem(14),
        },
    },
};

export default input;
